import { defineComponent as _defineComponent } from 'vue'
import QDataTableHeader from '@/components/datatables/base/QDataTableHeader.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  emits: ['reset-data'],
  setup(__props) {

  // TODO: QDataTableHeader must be in shared module
  

return { __sfc: true,QDataTableHeader }
}

})